export default __webpack_public_path__ + "static/media/add_comment.a1132d23.svg";